// File Metadata:
// Filename: authSlice.js
// Version: 1.00
// Created: 2022-09-27 23:23:17
// Last Modified: 2025-04-01 17:27:27
// Authors: [Your Name]
// Description: A brief summary of what this file does

import { createSlice } from '@reduxjs/toolkit'
import { tokenService } from '../../services/tokenService'
import jwtDecode from 'jwt-decode'

const getUserFromToken = (token) => {
    if (!token) return null;
    try {
        const decoded = jwtDecode(token);
        return {
            username: decoded.UserInfo.username,
            roles: decoded.UserInfo.roles,
            employeeId: decoded.UserInfo.employeeId,
            id: decoded.UserInfo.id
        };
    } catch {
        return null;
    }
};

const initialToken = tokenService.getToken();

const authSlice = createSlice({
    name: 'auth',
    initialState: { 
        user: getUserFromToken(initialToken), 
        token: initialToken,
        persist: JSON.parse(localStorage.getItem("persist")) || false
    },
    reducers: {
        setCredentials: (state, action) => {
            const { accessToken, roles, ...userData } = action.payload
            state.token = accessToken
            // Ensure user object has roles
            state.user = {
                roles: roles || { Employee: true },  // Always include roles
                ...userData
            }
            state.persist = JSON.parse(localStorage.getItem("persist")) || false
            // Store token in localStorage
            tokenService.setToken(accessToken)
        },
        logOut: (state) => {
            state.user = null
            state.token = null
            // Clear token from localStorage
            tokenService.clearTokens()
        },
        setPersist: (state, action) => {
            state.persist = action.payload
        }
    }
})

export const { setCredentials, logOut, setPersist } = authSlice.actions

export default authSlice.reducer

export const selectCurrentUser = (state) => state.auth.user
export const selectCurrentToken = (state) => state.auth.token
